
$.fn.showIf = function (condition) {
    if (condition) {
        $(this).show();
    } else {
        $(this).hide();
    }
};

$.fn.hideIf = function (condition) {
    if (condition) {
        $(this).hide();
    } else {
        $(this).show();
    }
};

$.fn.enableIf = function (condition) {
    if (!condition) {
        $(this).attr('disabled', 'true');
    } else {
        $(this).removeAttr('disabled');
    }
};

$.fn.disableButton = function () {
    $(this).enableIf(false);
    $(this).blur();
}
$.fn.enableButton = function () { $(this).enableIf(true); }

$.fn.enableNextBtnIf = function (condition) {
    $(this).enableIf(condition);
};

$.fn.bindChangedHandler = function (handler) {
    $(this).change(handler).keyup(handler);
}

$.fn.isChecked = function () {
    return $(this).prop('checked');
};

$.fn.setChecked = function(checked) {
    return $(this).prop('checked', checked);
}

$.fn.isVisible = function () {
    return $(this).is(':visible');
};

$.fn.addClassIf = function (styleClass, condition) {
    if (condition) {
        this.addClass(styleClass);
    } else {
        this.removeClass(styleClass);
    }
};
